module.exports = __webpack_public_path__ + "static/img/contract.5257da32.png";